import { inject } from '@angular/core';
import {HttpInterceptorFn, HttpHandlerFn, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { environment } from '../environments/environment';
import { AuthService } from '../services/auth.service';
import {catchError, EMPTY, map, of, switchMap, tap, throwError} from 'rxjs';
import {MessageService} from 'primeng/api';
import {Router} from '@angular/router';
import isEqual from 'lodash.isequal';
import {formatApiError} from '../comon/helpers/helper';
import {UserService} from '../services/user.service';
import {UserStateService} from '../states/user-state.service';

export const apiUrlInterceptor: HttpInterceptorFn = (req, next: HttpHandlerFn) => {
  const service = inject(AuthService);
  const messageService = inject(MessageService);
  const router = inject(Router);

  const isExternalUrl = /^https?:\/\//.test(req.url);
  const isAuthUrl = req.url.startsWith('/auth');
  const token = service.getToken();
  const userService = inject(UserService);
  const userState = inject(UserStateService);

  let modifiedReq = req;

  if (!isExternalUrl) {
    modifiedReq = modifiedReq.clone({
      url: `${environment.apiUrl}${req.url}`
    });

    if (token && !isAuthUrl) {
      modifiedReq = modifiedReq.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  }

  return next(modifiedReq).pipe(
    switchMap((event: any) => {
      if (event instanceof HttpResponse) {
        const newToken = event.headers.get('X-New-Access-Token');
        if (newToken) {
          service.setToken(newToken);
          return userService.getUser().pipe(
            tap(user => {
              if (!isEqual(user, userState.user())) {
                location.reload();
              }
            }),
            map((_) => event)
          )
        }
        return of(event);
      }
      return of(event);
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        console.warn(`Пойман ${error.status} ошибка!`);
        router.navigate(['/no-access'], { state: { status: error.status } });
      } else if (error.status === 401) {
        console.warn(`Пойман ${error.status} ошибка!`);
        service.removeToken();
        router.navigate(['/no-access'], { state: { status: error.status } });
      } else {
        messageService.add({ severity: 'error', summary: 'Ошибка', detail: formatApiError(error), life: 6000 });
      }
      return throwError(() => error);
    })
  );
};
